import routerOptions0 from "/codebuild/output/src3975238830/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@24.7.0_db0@0.3.4_eslint@9.37.0_jiti@1.21._4b8b6c88da3108ad874f2c506e8c7f7d/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}